export default {
  blockUi: (state) => state.blockUi,
  filters: (state) => state.filters,
  spinnerStatus: (state) => state.spinner.status,
  instrumentoCalibracao: (state) => state.instrumentoCalibracao,
  procedimentoEletronicoCalibracao: (state) => state.procedimentoEletronicoCalibracao,
  abaKanban: (state) => state.abaKanban,
  recarregaValores: (state) => state.recarregaValores,
}
